export const NEW_DISTRIBUTION_FORM = "configNewDistributionForm";
export const DELETE_DISTRIBUTION_FORM = "configDeleteDistributionForm";